module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/DailyPrecipitation200/Nagano_DailyPrecipitation200_MRI_RCP85_End.png";